import { AdCardItem } from "src/pages/ad-studio/insights/performance/view/ad-card-item";
import { ParentCard } from "src/pages/ad-studio/insights/performance/view/parent-card";
import type { CardState } from "src/pages/ad-studio/insights/performance/view/types";

type PerformanceCardProps = { card: CardState };

export const PerformanceCard = ({ card }: PerformanceCardProps) => {
  switch (card.kind) {
    case "ad": {
      return (
        <AdCardItem
          name={card.name}
          media={card.media}
          pills={card.pills}
          metrics={card.metrics}
        />
      );
    }
    case "parent": {
      return <ParentCard name={card.name} metrics={card.metrics} />;
    }
    case "group": {
      return (
        <AdCardItem
          name={card.title}
          media={card.media}
          pills={card.pills}
          metrics={card.metrics}
        />
      );
    }
    default: {
      return card satisfies never;
    }
  }
};
